import * as Yup from 'yup';

import PriceInfo from './Components/PriceInfo';

const headers = [
  {
    id: "brand_name",
    label: "Brand",
    size: {xs: 12, lg: 6},
  },
  {
    id: "length",
    label: "Length",
    size: {xs: 12, lg: 6},
  },
  {
    id: "colors",
    label: "Colors",
    array: true,
    size: {xs: 12, lg: 6},
  },
  {
    id: "types",
    label: "Types",
    array: true,

    size: {xs: 12, lg: 6},
  },
  {
    id: "price",
    label: "Retail Price",
    currency: true,
    size: {xs: 12, lg: 6},
  }
]

const filters = [
  
]

const fields = [
 {
    fieldType: "debounceSearchSolo",
    name: "brand_name",
    label: "Select Wig Brand",
    url: "vendors/brands",
    fieldName: "brand_name",
    displayField: "brand_name",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "divider",
    header: "Price Information",
    size: {xs: 12, lg: 12},
  },
  {
    fieldType: "Component",
    Component: <PriceInfo />,
    name: "price_info",
    size: {xs: 12, lg: 12},
  }
]


const initialValues = {
  brand_name: "",
  length: "",
  colors: [],
  types: [],
  cost: "",
  price: "",
}

const schema = Yup.object().shape({
  brand_name: Yup.string(),
});

export { fields, schema, initialValues, headers, filters };
